import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-follow-careonline',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './follow-careonline.component.html',
  styleUrls: ['./follow-careonline.component.scss']
})
export class FollowCareonlineComponent implements OnInit {

  @Input('title') title: any = 'Follow GigSumo ';
  @Input() suggestion: any;

  headerTitle: any = 'Follow GigSumo ';

  constructor() {
    this.headerTitle = this.title;
  }

  ngOnInit() {
  }

}
